import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { DataSessionService } from '../../core/services/data-session.service';
import { ContentComponent } from '../contents/content/content.component';
import { ContentService } from '../contents/services/content.service';
import { SpinnerService } from '../../core/services/spinner.service';
import { Subscription } from 'rxjs';
import { UserSessionData } from '../../core/types/session-data';
import { Content, ContentResponse } from '../../components/contents/type/content';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, IonicModule, TranslateModule, ContentComponent],
  providers: [],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent implements OnInit, OnDestroy {
  userData!: UserSessionData | null;
  privateContenData!: Content[] | [];
  publicContenData!: Content[] | [];
  subscription: Subscription = new Subscription();

  constructor(
    private readonly _dataSessionService: DataSessionService,
    private readonly _contentService: ContentService,
    private readonly _spinnerService: SpinnerService
  ) {
    this.userData = this._dataSessionService.userData;
  }

  ngOnInit(): void {
    this.getContent();
  }

  getContent(): void {
    this._spinnerService.show();
    const sub = this._contentService.getContentsHome().subscribe({
      next: (response) => {
        const contentResponse: ContentResponse = response;
        const contenData: Content [] = contentResponse.contents;
        this.publicContenData = contenData.filter((content: Content) => content.public === true);
        this.privateContenData = contenData.filter((content: Content) => content.public === false);
      },
      error: (err) => {
        this._spinnerService.hide();
      },
      complete: () => {
        this._spinnerService.hide();
      },
    });
    this.subscription.add(sub);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
